export default __webpack_public_path__ + "static/pattern-style-1-0ee4bd08f54efd91f8b6ceffcf531ff4.png";